<template>
    <div v-if="currentGift" class="gift">
        <div class="gift-product-img">
            <UiImage v-if="imagePath" :path="imagePath" :desktop="{ width: 1016 }" alt="" :lazy="false" />
            <ImagePlug v-else />
        </div>

        <div class="gift-details">
            <div class="text_19">подарочная карта post post scriptum</div>

            <div class="gift-details__type-toggle">
                <div
                    class="info__button text_15 info__button--disabled"
                    :class="{ 'info__button--current': isOfflineGift }">
                    подарочная упаковка
                    <sup class="subtitle text_9 color-accent" :class="{ 'subtitle--mobile': $device.isMobile }"
                        >скоро</sup
                    >
                </div>

                <div
                    class="info__button text_15"
                    :class="{ 'info__button--current': isVirtualGift }"
                    @click="setGiftType('virtual')">
                    виртуальная
                </div>
            </div>

            <Input type="text" class="" label="номинал" name="nominal" :value="nominal" disabled />

            <div class="gift-nominals">
                <div
                    v-for="(gift, key) in gifts"
                    :key="key"
                    @click="setGift(key)"
                    class="gift-nominals__nominal"
                    :class="{ 'gift-nominals__nominal--active': gift.id === currentGift.id }">
                    {{ gift.price }} ₽
                </div>
            </div>

            <template>
                <div
                    v-if="isVirtualGift"
                    @click="openModal"
                    class="buy-button buy-button--wide button button--wide button--dark">
                    оплатить
                </div>
                <div v-if="isOfflineGift" class="buy-button buy-button--wide button button--wide button--dark">
                    в корзину
                </div>
            </template>

            <MinimizedDescription
                v-if="nominalTextSecondPart && nominalTextFirstPart"
                :maxHeight="'0'"
                class="minimized text_15">
                <template v-slot:no-wrap>
                    <pre>{{ nominalTextFirstPart }}</pre>
                </template>
                <pre>{{ nominalTextSecondPart }}</pre>
            </MinimizedDescription>
            <MinimizedDescription v-else-if="currentGift.nominal_text" class="minimized text_15">
                <pre>{{ currentGift.nominal_text }}</pre>
            </MinimizedDescription>
        </div>

        <GiftPaymentModal
            v-if="showModal"
            v-bsl="$device.isDesktop"
            :gift="currentGift"
            :errors="errors"
            @close="closeModal"
            @payment="payment" />
    </div>
</template>

<script>
import Input from "@/components/form/Input.vue";
import MinimizedDescription from "@/components/MinimizedDescription.vue";
import ImagePlug from "@/components/ImagePlug.vue";
import GiftPaymentModal from "@/components/ui/GiftPaymentModal.vue";
import UiImage from "@/components/ui/Image.vue";
export default {
    name: "gift-card",
    components: { UiImage, GiftPaymentModal, ImagePlug, MinimizedDescription, Input },
    props: {
        asComponent: {
            type: Boolean,
            default: false,
        },
    },
    head() {
        return {
            script: [
                {
                    src: "https://widget.cloudpayments.ru/bundles/cloudpayments",
                },
            ],
        };
    },
    async fetch() {
        const { data: gifts } = await this.$axios.get("/api/gifts");
        this.gifts = gifts;
        const sortedByPrice = [...gifts].sort((a, b) => a.price - b.price);
        this.currentGift = sortedByPrice[0];
    },

    data() {
        return {
            gifts: [],
            currentGift: null,
            currentGiftType: "virtual",
            showModal: false,
            errors: {},
        };
    },
    computed: {
        isVirtualGift() {
            return this.currentGiftType === "virtual";
        },
        isOfflineGift() {
            return this.currentGiftType === "offline";
        },
        nominal() {
            return this.currentGift.price;
        },
        nominalTextFirstPart() {
            const text = this.currentGift.nominal_text?.split("{wrap}");

            if (!text) {
                return "";
            }

            return text[0];
        },
        nominalTextSecondPart() {
            const text = this.currentGift.nominal_text?.split("{wrap}");

            if (!text) {
                return "";
            }

            return text[1];
        },
        imagePath() {
            return this.currentGift?.images[0]?.path;
        },
    },
    methods: {
        setGiftType(type) {
            this.currentGiftType = type;
        },
        setGift(key) {
            this.currentGift = this.gifts[key];
        },
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        payment(formData) {
            this.$axios
                .post("/api/gifts/payment", formData)
                .then((res) => {
                    this.closeModal();
                    var widget = new cp.CloudPayments();
                    let that = this;
                    widget.pay("auth", res.data.payment_data, {
                        onSuccess: function () {
                            // that.goToSuccess(orderData, that.paymentData);
                        },
                        onFail: function (reason, options) {
                            console.log(`reason, options =>`, reason, options);
                        },
                        onComplete: function () {
                            console.dir(that);
                        },
                    });
                    return;
                })
                .catch((error) => {
                    if (error.response.status === 421) {
                        this.errors = {
                            type: formData.type,
                            data: error.response.data,
                        };
                        return;
                    }

                    console.log(error);
                });
        },
    },
    mounted() {
        if (!this.$props.asComponent) {
            this.$store.commit("crumbs/change", [{ name: this.$i18n.t("gift-certificates") }]);
        }
    },
};
</script>
<style lang="less">
.page-gifts .gift-details {
    @media @notsm {
        padding-top: 64px !important;
    }
}
</style>
<style scoped lang="less">
.gift {
    display: flex;
    @media @sm {
        flex-direction: column;
    }

    &-product-img {
        width: 50%;
        @media @sm {
            width: 100%;
        }
    }

    &-details {
        padding: 32px;
        width: 50%;
        @media @sm {
            padding: 16px;
            width: 100%;
        }

        &__type-toggle {
            display: flex;
            gap: 15px;
            margin-top: 24px;

            .subtitle {
                margin-top: -15px;

                &--mobile {
                    position: absolute;
                    top: -15px;
                    right: 0;
                    margin-top: unset;
                }
            }

            .info__button {
                position: relative;
                min-width: 32px;
                padding: 0 5px;
                height: 44px;
                border: 1px solid @border2;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                transition: border-color 0.3s ease 0s;
                cursor: pointer;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                width: 100%;

                &--current {
                    border-color: #000;
                }

                &--disabled {
                    color: gray;
                }
            }
        }
    }

    &-nominals {
        display: flex;
        gap: 24px;
        margin-top: 12px;
        color: #7b7b7b;

        @media @sm {
            gap: 9px;
            font-size: 11px;
        }

        &__nominal {
            cursor: pointer;

            &--active {
                color: #ff002a;
            }
        }
    }

    .minimized {
        margin-top: 40px;

        pre {
            white-space: break-spaces;
        }
    }

    .buy-button {
        margin-top: 24px;
    }
}
</style>
